import React, { memo, useState } from "react";
import { getDefaultComponentStyle } from "./utils/defaultStyles";
import defaultImg from "./assets/capCardElem.png";

// import css from "./index.less";

export default memo(
  ({
    data,
    getText,
  }: {
    data: IMultiElementCombineMsg.IHeaderElem;
    getText: (text: IMultiElementCombineMsg.IText) => string;
  }) => {
    const { title, text_color, textColor, icon_url } = data;

    const style = getDefaultComponentStyle(data) as any;

    const color = text_color || textColor;
    color && (style.color = `#${color}`);

    return (
      <div
        className={"sscard-headerBox"}
        style={{
          ...style,
          display: "flex",
        }}
      >
        {icon_url && (
          <span style={{ marginRight: "8px" }}>
            <img
              src={icon_url}
              style={{
                maxHeight: "25px",
                marginTop: "-2px",
              }}
              onError={(e) => ((e.target as any).src = defaultImg)}
              onClick={(e) => e.preventDefault()}
            />
          </span>
        )}
        <div
          style={{
            flex: 1,
            display: "-webkit-box",
          }}
        >
          {getText(title)}
        </div>
      </div>
    );
  }
);
